module.exports = __webpack_public_path__ + "static/rick-tolman-2120eda8efd476014b1977cd03b2aa0b.jpeg";